import React, { useEffect, useState } from "react";
import carewindow_blue from "images/carewindow_blue.png";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { resetPassword } from "js/Api/index";
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';

function Reset() {
    const [token, setToken] = useState("");
    const [isNewUser, setIsNewUser] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [passwordErrors, setPasswordErrors] = useState({
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false,
        noSpaces: true,
    });
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setToken(params.get("token"));
        setEmail(params.get("email"));
        setIsNewUser(params.get("isNewUser") === "true");
    }, [location.search]);

    useEffect(() => {
        if (password) {
            validatePassword(password);
        }
    }, [password]);

    const validatePassword = (pass) => {
        const passwordChecks = {
            length: pass.length >= 8,
            uppercase: /[A-Z]/.test(pass),
            lowercase: /[a-z]/.test(pass),
            number: /[0-9]/.test(pass),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(pass),
            noSpaces: !/\s/.test(pass),
        };

        setPasswordErrors((prev) => ({
            ...prev,
            ...passwordChecks,
        }));

        return Object.values(passwordChecks).every(Boolean);
    };

    const isPasswordValid = () => {
        return Object.values(passwordErrors).every(Boolean);
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission

        if (!password) {
            alert("Please enter an valid password.");
            return;
        }

        if (!isPasswordValid()) {
            alert("Password does not meet security requirements.");
            return;
        }

        const result = await resetPassword(email, password, token);

        if (result.success) {
            toast.success(result.message);
            navigate("/");
        } else {
        
        if (result.message.includes("Your link has expired")) {
            toast.error(
                <div>
                    Your link has expired. Please go to the{' '}
                    <Link 
                        to="/send_email" 
                        style={{ 
                            color: '#3b82f6', 
                            textDecoration: 'underline',
                            fontWeight: 'bold'
                        }}
                        onClick={() => toast.dismiss()}
                    >
                        Forgot Password
                    </Link>{' '}
                    page and generate a new password reset link.
                </div>,
                {
                    duration: 8000, 
                }
            );
        } else {
            toast.error(result.message);
        }
    }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="full_container">
            <Toaster />
            <div className="container">
                <div className="center verticle_center full_height">
                    <div className="login_section">
                        <div className="logo_login">
                            <div className="center">
                                <img className="login-carewindow" style={{ maxWidth: "80%" }} src={carewindow_blue} alt="CareWindow" />
                            </div>
                        </div>

                        <div className="login_form">
                            <div className="text-center mb-4">
                                
                                {isNewUser ? (
                                    <label style={{ fontSize: "22px", color: "#333333" }}>Set your password</label>
                                ) : (
                                    <label style={{ fontSize: "22px", color: "#333333" }}>Reset your password</label>
                                )}
                            </div>
                            <form id="reset-form" method="post" action="/reset" onSubmit={handleSubmit} >
                                <div class="form-group" style={{ position: "relative" }}>
                                    <label className="label_field">Password</label>
                                    <input class="form-control" type={showPassword ? "text" : "password"} id="Password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                                    <button type="button" onClick={togglePasswordVisibility} style={{
                                        position: "absolute", right: "10px",
                                        top: "38px", background: "none", border: "none", cursor: "pointer", padding: "0", fontSize: "16px",
                                        color: "#666"
                                    }}
                                    >
                                        {showPassword ? <VisibilityRoundedIcon fontSize="small" /> : <VisibilityOffRoundedIcon fontSize="small" />}
                                    </button>
                                </div>
                                <div class="form-group">
                                    <div className="password-requirements" style={{ border: "0px solid #ccc", borderRadius: "4px", width: "fit-content", fontSize: "11px", textAlign: "left" }} >
                                        <label className="label_field">
                                            Password must contain:
                                        </label>
                                        <ul style={{ margin: 0, padding: "0 0 0 15px", listStyleType: "none" }}>
                                            <li style={{ color: passwordErrors.length ? "green" : "red", marginBottom: "3px", fontSize: "11px" }}>
                                                {passwordErrors.length ? "✓" : "○"} At least 8 characters
                                            </li>
                                            <li style={{ color: passwordErrors.uppercase ? "green" : "red", marginBottom: "3px", fontSize: "11px" }}>
                                                {passwordErrors.uppercase ? "✓" : "○"} At least 1 uppercase letter
                                            </li>
                                            <li style={{ color: passwordErrors.lowercase ? "green" : "red", marginBottom: "3px", fontSize: "11px" }}>
                                                {passwordErrors.lowercase ? "✓" : "○"} At least 1 lowercase letter
                                            </li>
                                            <li style={{ color: passwordErrors.number ? "green" : "red", marginBottom: "3px", fontSize: "11px" }}>
                                                {passwordErrors.number ? "✓" : "○"} At least 1 number
                                            </li>
                                            <li style={{ color: passwordErrors.special ? "green" : "red", marginBottom: "3px", fontSize: "11px" }}>
                                                {passwordErrors.special ? "✓" : "○"} At least 1 special character
                                            </li>
                                            <li style={{ color: passwordErrors.noSpaces ? "green" : "red", marginBottom: "3px", fontSize: "11px" }}>
                                                {passwordErrors.noSpaces ? "✓" : "○"} No spaces allowed
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="form-group">
                                    {isNewUser ? (
                                        <button className="btn cur-p btn-primary" type="submit" > Set password </button>
                                    ) : (
                                        <button className="btn cur-p btn-primary" type="submit" > Reset password </button>
                                    )}
                                </div>
                                <div class="form-group">
                                    <div class="text-center">
                                        <Link to="/"> Return to Login Page </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Reset;